/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_SUB_AI_REPORTS_ITEM = {
  id: 'subscriptions_ai_reports',
  screenId: 'met-sub-ai-reports',
  label: 'Informes IA',
  description: 'Informes automáticos de suscripciones generados con inteligencia artificial.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Pedís un informe escrito que analiza cartera, altas/bajas, cuotas, cobranza y mix de planes. La IA resume números reales de tu empresa y sugiere acciones (retención, mora, planes, etc.).',
      },
      {
        title: 'Antes de empezar',
        bullets: [
          'Hace falta actividad de suscripciones o cartera activa; si no hay, el sistema avisa.',
          'Solo puede haber un informe de suscripciones en proceso a la vez.',
          'El rango de fechas no puede superar un año.',
        ],
      },
      {
        title: 'Paso 1 — Generar informe',
        bullets: [
          'Elegí el período con los atajos o Personalizado (desde / hasta + Aplicar).',
          'Tocá «Generar informe IA». Corre en segundo plano y queda guardado acá.',
          'Si tenés notificaciones activadas, recibirás un aviso cuando esté listo.',
        ],
      },
      {
        title: 'Paso 2 — Leer el informe',
        bullets: [
          'Resumen ejecutivo, destacados y gráficos (facturación, planes, altas/bajas, deudores).',
          'Secciones de cartera, crecimiento, facturación, cobranza y mix por plan.',
          'Recomendaciones, riesgos y notas sobre calidad de datos.',
        ],
      },
    ],
  },
}
